var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTagListView = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 3H1.5L1.5 6H9V3ZM1.5 1.5C0.671573 1.5 0 2.17157 0 3V6C0 6.82843 0.671573 7.5 1.5 7.5H9C9.82843 7.5 10.5 6.82843 10.5 6V3C10.5 2.17157 9.82843 1.5 9 1.5H1.5ZM19.5 3H13.5V6H19.5V3ZM13.5 1.5C12.6716 1.5 12 2.17157 12 3V6C12 6.82843 12.6716 7.5 13.5 7.5H19.5C20.3284 7.5 21 6.82843 21 6V3C21 2.17157 20.3284 1.5 19.5 1.5H13.5ZM1.5 10.5H6V13.5H1.5L1.5 10.5ZM0 10.5C0 9.67157 0.671573 9 1.5 9H6C6.82843 9 7.5 9.67157 7.5 10.5V13.5C7.5 14.3284 6.82843 15 6 15H1.5C0.671573 15 0 14.3284 0 13.5V10.5ZM22.5 10.5H10.5V13.5H22.5V10.5ZM10.5 9C9.67157 9 9 9.67157 9 10.5V13.5C9 14.3284 9.67157 15 10.5 15H22.5C23.3284 15 24 14.3284 24 13.5V10.5C24 9.67157 23.3284 9 22.5 9H10.5ZM1.5 18H15V21H1.5L1.5 18ZM0 18C0 17.1716 0.671573 16.5 1.5 16.5H15C15.8284 16.5 16.5 17.1716 16.5 18V21C16.5 21.8284 15.8284 22.5 15 22.5H1.5C0.671572 22.5 0 21.8284 0 21V18Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTagListView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag-list-view.6921c61bf27dc7c36474f7f07cc95ea2.svg";